import Container from "@/Components/Grid/Container";

import IconLayout from "@resources/show-apartment/why-icon-layout.png?format=webp&quality=90&imagetools";
import IconFinish from "@resources/show-apartment/why-icon-finish.png?format=webp&quality=90&imagetools";
import IconAdvisor from "@resources/show-apartment/why-icon-advisor.png?format=webp&quality=90&imagetools";
import IconLocation from "@resources/show-apartment/why-icon-location.png?format=webp&quality=90&imagetools";

const items = [
    {
        key: "layout",
        icon: IconLayout,
        title: "Poznasz układ mieszkania",
        description: "Sprawdź jak rozplanowano każdy metr przestrzeni",
    },
    {
        key: "finish",
        icon: IconFinish,
        title: "Sprawdzisz standard wykończenia",
        description:
            "Dotknij materiałów, zobacz jakość i detale wykończenia na żywo",
    },
    {
        key: "advisor",
        icon: IconAdvisor,
        title: (
            <>
                Porozmawiasz
                <br />z doradcą
            </>
        ),
        description:
            "Uzyskaj odpowiedzi na pytania i dopasuj do swoich potrzeb",
    },
    {
        key: "location",
        icon: IconLocation,
        title: (
            <>
                Zobaczysz inwestycję
                <br />
                na miejscu
            </>
        ),
        description:
            "Poznaj okolicę, części wspólne i udogodnienia w inwestycji",
    },
];

export const WhyVisitSection = () => {
    return (
        <section className="py-14 lg:py-18">
            <Container>
                <h2 className="text-primary text-h3 leading-[40px] font-extrabold uppercase tracking-[0.8px] text-center mb-[60px] maxMd:mb-10">
                    Dlaczego warto obejrzeć?
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-[27px]">
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className="flex flex-col items-center gap-5 p-8"
                        >
                            <img
                                src={item.icon}
                                alt=""
                                className="h-20 w-auto object-contain"
                                loading="lazy"
                            />
                            <div className="flex flex-col gap-3 w-full">
                                <h3 className="text-primary text-h4 leading-h4 font-extrabold tracking-[0.6px] text-center">
                                    {item.title}
                                </h3>
                                <p className="text-text text-p leading-p tracking-[0.45px] text-center">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};
